module.exports = __webpack_public_path__ + "img/pageinteriors_individuos-y-familias-01autos.47c3c254.jpg";